/**
 * External tasks v1 (260702) bod 2 — external-audience source for the reassign
 * target picker. Distinct from `useProjectExternalMembers` (which routes through
 * the internal client.ts admin/PM endpoint and would 403 + clear the internal
 * auth token for an external actor). This hook uses the external board API
 * client (cookie creds, isolated from internal token state).
 */
import { useQuery } from '@tanstack/react-query';
import {
  fetchProjectExternalMembers,
  type ExternalMember,
} from '../services/api/externalBoard';

export function useProjectExternalMembersExternal(projectId: number, enabled = true) {
  return useQuery<ExternalMember[], Error>({
    queryKey: ['external-project-members', projectId],
    queryFn: () => fetchProjectExternalMembers(projectId),
    enabled: enabled && Number.isFinite(projectId) && projectId > 0,
    staleTime: 10_000,
  });
}
